<template>
  <span
    class="nx-badge"
    :class="color"
    :style="{ color: fontColor, backgroundColor: outline ? 'transparent !important' : '' }">
    <span class="content"><slot></slot></span>
  </span>
</template>

<script>
export default {
  name: 'nx-badge',
  props: {
    color: {
      type: String,
      default: 'grey lighten-3',
    },
    fontColor: {
      type: String,
    },
    outline: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-badge {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 18px;
  border: 1px solid transparent;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 11px;
  margin: 2rpx;
  outline: none;
  position: relative;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  vertical-align: middle;
  .content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 28px;
    cursor: default;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 18px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 12px;
    vertical-align: middle;
    white-space: nowrap;
    z-index: 1;
  }
  + .nx-badge {
    margin-left: 8px
  }
}
</style>
